import React from "react";
import { Mail, MapPin, Phone} from "lucide-react";
import { siteData} from "../data/siteData";

const contact = siteData.contact;

const ContactInfo = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Address - Full Width */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md flex items-start gap-4 transition duration-300 hover:scale-[1.02] hover:shadow-lg">
        <MapPin className="w-6 h-6 text-blue-600 mt-1" />
        <div>
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
            Address
          </h3>
          <p className="text-sm text-blue-500 dark:text-gray-300">
            {contact.address}
          </p>
        </div>
      </div>

      {/* Phone & Email - Side by Side on Large Screens */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Phone */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md flex items-start gap-4 transition duration-300 hover:scale-[1.02] hover:shadow-lg">
          <Phone className="w-6 h-6 text-green-600 mt-1" />
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              Phone
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              <a href={`tel:${contact.phone1}`} className="text-blue-500 hover:underline">
                {contact.phone1}
              </a>
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              <a href={`tel:${contact.phone2}`} className="text-blue-500 hover:underline">
                {contact.phone2}
              </a>
            </p>
          </div>
        </div>

        {/* Email */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md flex items-start gap-4 transition duration-300 hover:scale-[1.02] hover:shadow-lg">
          <Mail className="w-6 h-6 text-red-600 mt-1" />
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              Email
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              <a href={`mailto:${contact.email}`} className="text-blue-500 hover:underline">
                {contact.email}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
);
};

export default ContactInfo;